/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PatchedStaticPageRequest
 */
export interface PatchedStaticPageRequest {
  /**
   *
   * @type {string}
   * @memberof PatchedStaticPageRequest
   */
  slug?: string
  /**
   *
   * @type {string}
   * @memberof PatchedStaticPageRequest
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof PatchedStaticPageRequest
   */
  header?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedStaticPageRequest
   */
  titleTag?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedStaticPageRequest
   */
  descriptionTag?: string | null
  /**
   *
   * @type {string}
   * @memberof PatchedStaticPageRequest
   */
  canonicalUrl?: string | null
  /**
   *
   * @type {number}
   * @memberof PatchedStaticPageRequest
   */
  serviceId?: number | null
}

/**
 * Check if a given object implements the PatchedStaticPageRequest interface.
 */
export function instanceOfPatchedStaticPageRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function PatchedStaticPageRequestFromJSON(json: any): PatchedStaticPageRequest {
  return PatchedStaticPageRequestFromJSONTyped(json, false)
}

export function PatchedStaticPageRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedStaticPageRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    slug: !exists(json, 'slug') ? undefined : json['slug'],
    name: !exists(json, 'name') ? undefined : json['name'],
    header: !exists(json, 'header') ? undefined : json['header'],
    titleTag: !exists(json, 'titleTag') ? undefined : json['titleTag'],
    descriptionTag: !exists(json, 'descriptionTag') ? undefined : json['descriptionTag'],
    canonicalUrl: !exists(json, 'canonicalUrl') ? undefined : json['canonicalUrl'],
    serviceId: !exists(json, 'serviceId') ? undefined : json['serviceId'],
  }
}

export function PatchedStaticPageRequestToJSON(value?: PatchedStaticPageRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    slug: value.slug,
    name: value.name,
    header: value.header,
    titleTag: value.titleTag,
    descriptionTag: value.descriptionTag,
    canonicalUrl: value.canonicalUrl,
    serviceId: value.serviceId,
  }
}
